import { gql } from '@apollo/client';

import { StudentOnlineApplicationFragment } from '@modules/students/graphql';

export const GetStudentOnlineApplicationQuery = gql`
    query GetStudentOnlineApplication {
        getStudentOnlineApplication {
            ...StudentOnlineApplication
        }
    }
    ${StudentOnlineApplicationFragment}
`;
